var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('OrdersSuperiorMenu'),(!_vm.orders.length)?_c('v-card',{staticClass:"ma-10",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(" Todavía no se ha realizado ningún pedido. ")]),_c('v-card-text',[_vm._v(" Continúa comprando "),_c('router-link',{attrs:{"to":"/articles"}},[_vm._v("aquí")])],1)],1):_c('div',[_c('OrdersList')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }